export enum PlanStatusEnum {
  'ACTIVE' = 'ACTIVE',
  'INACTIVE' = 'INACTIVE',
  'TRIALING' = 'TRIALING',
  'EXPIRED' = 'EXPIRED',
  'PENDING' = 'PENDING',
  'DELINQUENT' = 'DELINQUENT',
}

export enum PlanNameEnum {
  TRIAL = 'Trial',
  FIRST_PROJECT_FREE = 'First Project Free',
  LIFETIME_DEAL = 'Lifetime Deal',
}
